import React from 'react';
import { CopyIcon } from 'lucide-react';
import toast from 'react-hot-toast';

interface FailureLogModalProps {
  requestPayload?: string | null;
  responsePayload?: string | null;
  onClose: () => void;
}

export const FailureLogModal: React.FC<FailureLogModalProps> = ({
  requestPayload,
  responsePayload,
  onClose,
}) => {
  const handleCopy = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copied to clipboard`);
  };

  const formatPayload = (payload?: string | null) => {
    if (!payload) return 'No payload available';
    try {
      // Try to format it as JSON if possible
      const parsed = JSON.parse(payload);
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      // If it's not JSON, return the raw string
      return payload;
    }
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-lg w-full max-w-4xl max-h-[85vh] flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Shipment Failure Logs</h2>

      </div>

      <div className="flex-1 overflow-y-auto pr-2 grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Request Section */}
        <div className="flex flex-col bg-gray-50 rounded-lg border">
          <div className="flex justify-between items-center p-3 bg-gray-100 border-b rounded-t-lg">
            <h3 className="font-semibold text-gray-700">Request Payload</h3>
            <button
              onClick={() => handleCopy(requestPayload || '', 'Request payload')}
              className="p-1 hover:bg-gray-200 rounded text-gray-600"
              title="Copy Request"
            >
              <CopyIcon className="w-4 h-4" />
            </button>
          </div>
          <pre className="p-4 overflow-x-auto text-xs text-gray-800 whitespace-pre-wrap flex-1">
            {formatPayload(requestPayload)}
          </pre>
        </div>

        {/* Response Section */}
        <div className="flex flex-col bg-gray-50 rounded-lg border">
          <div className="flex justify-between items-center p-3 bg-gray-100 border-b rounded-t-lg">
            <h3 className="font-semibold text-gray-700">Response Payload</h3>
            <button
              onClick={() => handleCopy(responsePayload || '', 'Response payload')}
              className="p-1 hover:bg-gray-200 rounded text-gray-600"
              title="Copy Response"
            >
              <CopyIcon className="w-4 h-4" />
            </button>
          </div>
          <pre className="p-4 overflow-x-auto text-xs text-gray-800 whitespace-pre-wrap flex-1">
            {formatPayload(responsePayload)}
          </pre>
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  );
};
